<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import KanbanListSection from './components/KanbanListSection.vue';
import { useKanbanListColumns } from 'dashboard/composables/useKanbanListColumns';

const props = defineProps({
  pipeline: { type: Object, required: true },
  cardsByColumn: { type: Function, required: true },
});

const emit = defineEmits(['cardClick']);

const store = useStore();
const currentUserId = computed(() => store.getters.getCurrentUser?.id);

const opportunityAttributes = computed(
  () =>
    store.getters['attributes/getAttributesByModel']('opportunity_attribute') ??
    []
);

const { columns, hideColumn, showColumn, reorderColumn } = useKanbanListColumns(
  {
    pipelineId: props.pipeline.id,
    userId: currentUserId.value,
    customAttributes: opportunityAttributes.value,
  }
);

const visibleColumns = computed(() => columns.value.filter(c => c.visible));
const hiddenColumns = computed(() => columns.value.filter(c => !c.visible));

const orderedStages = computed(() =>
  [...(props.pipeline.columns ?? [])].sort((a, b) => a.position - b.position)
);

function onReorderColumn({ key, newIndex }) {
  reorderColumn(key, newIndex);
}
</script>

<template>
  <div class="flex-1 overflow-y-auto min-h-0 pb-20 md:pb-0">
    <KanbanListSection
      v-for="stage in orderedStages"
      :key="stage.id"
      :stage="stage"
      :cards="cardsByColumn(stage.id)"
      :columns="visibleColumns"
      :hidden-columns="hiddenColumns"
      :pipeline-category="pipeline.category"
      @card-click="card => emit('cardClick', card)"
      @reorder-column="onReorderColumn"
      @hide-column="hideColumn"
      @add-column="showColumn"
    />
  </div>
</template>
